import React from 'react';

const Error = (props) => {
 
  return (<div>서버 장애로 인한 데이터 조회 오류</div>);
};

export default Error;